import React from 'react';
import { connect } from 'react-redux';

import Mapbox from './mapbox.js'

class MapContainer extends React.Component {

    render() {
        let render = this.props.loadedLevels.length !== 0 || this.props.loadedMap;
        return( 
            render ? <Mapbox/> : <div></div>
        )
    } 
}

function mapStateToProps( state ){
    return {
        loadedLevels : state.loadedLevels,
        loadedMap    : state.switches.loadedMap,
    }
}

export default connect(mapStateToProps)(MapContainer);